import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Header } from "./WorkspacesTab";

const FIELDS = [
  { key: "assistant", label: "Master Assistant Prompt", hint: "Platform-regels die vóór elke tenant-brand-context staan voor The Brand Assistant." },
  { key: "writer", label: "Master Writer Prompt", hint: "Platform-regels voor The Brand Writer." },
  { key: "creator", label: "Master Creator Prompt", hint: "Platform-regels voor The Brand Creator." },
];

export default function AiPromptsTab() {
  const [values, setValues] = useState({ assistant: "", writer: "", creator: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/super-admin/config");
        setValues(data.ai_prompts || { assistant: "", writer: "", creator: "" });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Kon prompts niet laden");
      } finally { setLoading(false); }
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/super-admin/config", { ai_prompts: values });
      toast.success("Prompts opgeslagen");
      setDirty(false);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Opslaan mislukt");
    } finally { setSaving(false); }
  };

  return (
    <div data-testid="sa-ai-prompts">
      <Header title="AI Prompts" sub="Master-prompts worden vooraan geplaatst voor élke tenant AI-call. De merk-specifieke instructies blijven als aanvulling werken." />
      {loading ? (
        <div className="text-sm text-gray-500">Laden…</div>
      ) : (
        <>
          <div className="space-y-6">
            {FIELDS.map((f) => (
              <div key={f.key} className="rounded-[var(--global-radius-xl)] border border-gray-200 bg-white p-5">
                <label className="block mb-2">
                  <div className="text-sm font-medium text-[#1a1a1a]">{f.label}</div>
                  <div className="text-xs text-gray-500">{f.hint}</div>
                </label>
                <textarea
                  value={values[f.key] || ""}
                  onChange={(e) => { setValues({ ...values, [f.key]: e.target.value }); setDirty(true); }}
                  rows={8}
                  placeholder={`Platform-regels voor ${f.label.replace("Master ", "")}…`}
                  className="w-full bg-[#fafafa] border border-gray-200 rounded-[var(--global-radius)] p-3 text-sm font-mono text-[#1a1a1a] resize-y focus:outline-none focus:border-gray-400"
                  data-testid={`sa-prompt-${f.key}`}
                />
              </div>
            ))}
          </div>
          <div className="mt-6 flex justify-end">
            <Button
              onClick={save}
              disabled={!dirty || saving}
              data-testid="sa-prompts-save"
              className="h-10 px-6 rounded-[var(--global-radius)] bg-[var(--global-action)] text-white hover:opacity-90 disabled:opacity-50"
            >
              {saving ? "Opslaan…" : "Opslaan"}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
